import { Data } from "dataclass";
// import { getStates } from "../../Inventory/_redux/suppliers/suppliersCrud";
// import jwt_decode from "jwt-decode";
// import { ContentRoute } from "../../../../_metronic/layout";
// import { Notification } from "../partials/Notification";

class PermissionGroupItem extends Data {
  id = 0;
  key = "";
  title = "";
  permissions() {
    const perms = [];
    for (const permission of Object.values(Permission)) {
      if (permission.groups.includes(this)) {
        perms.push(permission);
      }
    }
    return perms;
  }
}

class PermissionItem extends Data {
  id = 0;
  title = "";
  groups = [];
}

export const PermissionGroup = {
  All: PermissionGroupItem.create({ id: 1, key: "All", title: "All Permissions" }),
  Brand: PermissionGroupItem.create({ id: 2, key: "Brand", title: "Brand All Permissions" }),
  Category: PermissionGroupItem.create({ id: 3, key: "Category", title: "Category All Permissions" }),
  Product: PermissionGroupItem.create({ id: 4, key: "Product", title: "Product All Permissions" }),
  Attribute: PermissionGroupItem.create({ id: 5, key: "Attribute", title: "Attribute All Permissions" }),
  AttributeGroup: PermissionGroupItem.create({ id: 6, key: "AttributeGroup", title: "AttributeGroup All Permissions" }),
  PurchaseOrder: PermissionGroupItem.create({ id: 7, key: "PurchaseOrder", title: "PurchaseOrder All Permissions" }),
  Stock: PermissionGroupItem.create({ id: 8, key: "Stock", title: "Stock All Permissions" }),
  Channel: PermissionGroupItem.create({ id: 9, key: "Channel", title: "Channel All Permissions" }),
  Supplier: PermissionGroupItem.create({ id: 10, key: "Supplier", title: "Supplier All Permissions" }),
  Customer: PermissionGroupItem.create({ id: 11, key: "Customer", title: "Customer All Permissions" }),
  SaleOrder: PermissionGroupItem.create({ id: 12, key: "SaleOrder", title: "SaleOrder All Permissions" }),
  Payment: PermissionGroupItem.create({ id: 13, key: "Payment", title: "Payment All Permissions" }),
  Reporting: PermissionGroupItem.create({ id: 14, key: "Reporting", title: "Reporting All Permissions" }),
  Tag: PermissionGroupItem.create({ id: 15, key: "Tag", title: "Tag All Permissions" }),
  Coupon: PermissionGroupItem.create({ id: 16, key: "Coupon", title: "Coupon All Permissions" }),
  Ecom: PermissionGroupItem.create({ id: 17, key: "Ecom", title: "Ecom All Permissions" }),
  CatalogModule: PermissionGroupItem.create({ id: 27, key: "CatalogModule", title: "CatalogModule All Permissions" }),
  SaleModule: PermissionGroupItem.create({ id: 28, key: "SaleModule", title: "SaleModule All Permissions" }),
  AddSaleOrder: PermissionGroupItem.create({ id: 19, key: "AddSaleOrder", title: "SaleOrder All Permissions" }),
  AddProduct: PermissionGroupItem.create({ id: 22, key: "AddProduct", title: "AddProduct All Permissions" }),
  User: PermissionGroupItem.create({ id: 18, key: "User", title: "User All Permissions" }),
  AddPurchaseOrder: PermissionGroupItem.create({
    id: 23,
    key: "AddPurchaseOrder",
    title: "AddPurchaseOrder All Permissions",
  }),
  StockTransfer: PermissionGroupItem.create({
    id: 24,
    key: "StockTransfer",
    title: "Stock Transfer All Permissions",
  }),
  InventaryModule: PermissionGroupItem.create({
    id: 20,
    key: "InventaryModule",
    title: "InventaryModule All Permissions",
  }),
  ForStockUpdate: PermissionGroupItem.create({
    id: 29,
    key: "ForStockUpdate",
    title: "ForStockUpdate All Permissions",
  }),
  BalanceAdjustment: PermissionGroupItem.create({ id: 21, key: "BalanceAdjustment", title: "Balance Adjustment All Permissions" }),

  ReportModule: PermissionGroupItem.create({ id: 21, key: "ReportModule", title: "ReportModule All Permissions" }),
  JournalEntry: PermissionGroupItem.create({ id: 28, key: "JournalEntryModule", title: "JournalEntry All Permissions" }),
  AccessDeliveryModule: PermissionGroupItem.create({ id: 25, key: "AccessDeliveryModule", title: "AccessDeliveryModule All Permissions" }),
  VehicleAcess: PermissionGroupItem.create({
    id: 26,
    key: "VehicleAccess",
    title: "Vehicle Access All Permissions",
  }),
  Konnect: PermissionGroupItem.create({ id: 30, key: "Konnect", title: "Konnect All Permissions" }),
  ChartOfAccounts: PermissionGroupItem.create({ id: 31, key: "ChartOfAccounts", title: "Chart of Accounts All Permissions" }),
  ExpenseBillVendor: PermissionGroupItem.create({ id: 32, key: "ExpenseBillVendor", title: "Expense / Bill / Vendor All Permissions" }),
  BankingGroup: PermissionGroupItem.create({ id: 34, key: "Banking", title: "Banking All Permissions" }),
  DepartmentGroup: PermissionGroupItem.create({ id: 35, key: "Department", title: "Department All Permissions" }),
  Spiff: PermissionGroupItem.create({ id: 36, key: "Spiff", title: "Spiff All Permissions" }),
  Kai: PermissionGroupItem.create({ id: 37, key: "Kai", title: "KAI All Permissions" }),
};

export const Permission = {
  // Dashboard Permission
  DashboardView: PermissionItem.create({
    id: 254,
    title: "View Dashboard",
    groups: [PermissionGroup.All],
  }),
  AIBulletinView: PermissionItem.create({
    id: 245,
    title: "View AI-Bulletin",
    groups: [PermissionGroup.All, PermissionGroup.Reporting],
  }),
  // Brand Permissions
  BrandView: PermissionItem.create({
    id: 10,
    title: "View Brand",
    groups: [PermissionGroup.All, PermissionGroup.Brand, PermissionGroup.CatalogModule, PermissionGroup.AddProduct],
  }),
  // BrandCreate : PermissionItem.create({id:11, title:"Add new Brand", groups:[PermissionGroup.All, PermissionGroup.Brand]}),
  BrandUpdate: PermissionItem.create({
    id: 12,
    title: "Update Brand",
    groups: [PermissionGroup.All, PermissionGroup.Brand, PermissionGroup.CatalogModule],
  }),
  // BrandRemove : PermissionItem.create({id:13, title:"Delete Brand", groups:[PermissionGroup.All, PermissionGroup.Brand]}),

  // Category Permissions
  CategoryView: PermissionItem.create({
    id: 20,
    title: "View Category",
    groups: [PermissionGroup.All, PermissionGroup.Category, PermissionGroup.CatalogModule, PermissionGroup.AddProduct],
  }),
  // CategoryCreate : PermissionItem.create({
  //:    id=21: title="Add new Category", groups:[PermissionGroup.All, PermissionGroup.Category]}
  // )
  CategoryUpdate: PermissionItem.create({
    id: 22,
    title: "Update Category",
    groups: [PermissionGroup.All, PermissionGroup.Category, PermissionGroup.CatalogModule],
  }),
  // CategoryRemove : PermissionItem.create({
  //:    id=23: title="Delete Category", groups:[PermissionGroup.All, PermissionGroup.Category]}
  // )

  // Product Permissions
  ProductView: PermissionItem.create({
    id: 30,
    title: "View Product",
    groups: [
      PermissionGroup.All,
      PermissionGroup.Product,
      PermissionGroup.CatalogModule,
      PermissionGroup.AddSaleOrder,
      PermissionGroup.AddPurchaseOrder,
      PermissionGroup.ForStockUpdate,
    ],
  }),
  // ProductCreate : PermissionItem.create({
  //:    id=31: title="Add new Product", groups:[PermissionGroup.All, PermissionGroup.Product]}
  // )
  ProductUpdate: PermissionItem.create({
    id: 32,
    title: "Update Product",
    groups: [PermissionGroup.All, PermissionGroup.Product, PermissionGroup.CatalogModule, PermissionGroup.AddProduct],
  }),
  HideCostPrices: PermissionItem.create({
    id: 271,
    title: "Hide Cost Prices",
    groups: [PermissionGroup.All, PermissionGroup.Product, PermissionGroup.Stock],
  }),
  ViewProductCostInSOOpenSheets: PermissionItem.create({
    id: 272,
    title: "View Product Cost in SO Open Sheets",
    groups: [PermissionGroup.All, PermissionGroup.SaleOrder],
  }),
  // ProductRemove : PermissionItem.create({id:33: title:"Delete Product"},
  // groups=[PermissionGroup.All, PermissionGroup.Product])

  // Attribute Permissions
  AttributeView: PermissionItem.create({
    id: 40,
    title: "View Attribute",
    groups: [PermissionGroup.All, PermissionGroup.Attribute, PermissionGroup.CatalogModule],
  }),
  // AttributeCreate : PermissionItem.create({
  //:    id=41: title="Add new Attribute", groups:[PermissionGroup.All, PermissionGroup.Attribute]}
  // )
  AttributeUpdate: PermissionItem.create({
    id: 42,
    title: "Update Attribute",
    groups: [PermissionGroup.All, PermissionGroup.Attribute, PermissionGroup.CatalogModule],
  }),
  // AttributeRemove : PermissionItem.create({
  //:    id=43: title="Delete Attribute", groups:[PermissionGroup.All, PermissionGroup.Attribute]}
  // )

  // AttributeGroup Permissions
  AttributeGroupView: PermissionItem.create({
    id: 50,
    title: "View AttributeGroup",
    groups: [PermissionGroup.All, PermissionGroup.AttributeGroup, PermissionGroup.CatalogModule],
  }),
  // AttributeGroupCreate : PermissionItem.create({
  //:    id=51: title="Add new AttributeGroup", groups:[PermissionGroup.All, PermissionGroup.AttributeGroup]}
  // )
  AttributeGroupUpdate: PermissionItem.create({
    id: 52,
    title: "Update AttributeGroup",
    groups: [PermissionGroup.All, PermissionGroup.AttributeGroup, PermissionGroup.CatalogModule],
  }),
  // AttributeGroupRemove : PermissionItem.create({
  //:    id=53: title="Delete AttributeGroup", groups:[PermissionGroup.All, PermissionGroup.AttributeGroup]}
  // )

  // Tag permissions
  TagView: PermissionItem.create({
    id: 140,
    title: "View Tag",
    groups: [PermissionGroup.All, PermissionGroup.Tag, PermissionGroup.CatalogModule],
  }),
  // TagCreate : PermissionItem.create({id:141, title:"Add new Tag", groups:[PermissionGroup.All, PermissionGroup.Tag]}),
  TagUpdate: PermissionItem.create({
    id: 142,
    title: "Update Tag",
    groups: [PermissionGroup.All, PermissionGroup.Tag, PermissionGroup.CatalogModule],
  }),
  TagDelete: PermissionItem.create({ id: 143, title: "Delete Tag", groups: [PermissionGroup.All, PermissionGroup.Tag] }),

  ////////////////////////////////////////
  // Inventory Module //
  ////////////////////////////////////////

  // Purchase Order Permissions
  PurchaseOrderView: PermissionItem.create({
    id: 60,
    title: "View Purchase Order",
    groups: [PermissionGroup.All, PermissionGroup.PurchaseOrder, PermissionGroup.InventaryModule],
  }),
  // PurchaseOrderCreate : PermissionItem.create({
  //:    id=61: title="Add new Purchase Order", groups:[PermissionGroup.All, PermissionGroup.PurchaseOrder]}
  // )
  PurchaseOrderUpdate: PermissionItem.create({
    id: 62,
    title: "Update Purchase Order",
    groups: [PermissionGroup.All, PermissionGroup.PurchaseOrder, PermissionGroup.InventaryModule],
  }),
  PurchaseReceiveView: PermissionItem.create({
    id: 65,
    title: "View Purchase Receive",
    groups: [PermissionGroup.All, PermissionGroup.PurchaseReceive, PermissionGroup.InventaryModule],
  }),
  // PurchaseOrderRemove : PermissionItem.create({
  //:    id=63: title="Delete Purchase Order", groups:[PermissionGroup.All, PermissionGroup.PurchaseOrder]}
  // )

  // Stock Permissions
  StockView: PermissionItem.create({
    id: 70,
    title: "View Stock",
    groups: [PermissionGroup.All, PermissionGroup.Stock, PermissionGroup.InventaryModule, PermissionGroup.ForStockUpdate],
  }),
  // Warehouse locations (zone/aisle/bin). 275/276 = VehicleDelete/RouteDelete, 282 = KaiAccess.
  LocationView: PermissionItem.create({
    id: 284,
    title: "View Stock Locations",
    groups: [PermissionGroup.All, PermissionGroup.Stock, PermissionGroup.InventaryModule],
  }),
  LocationManage: PermissionItem.create({
    id: 283,
    title: "Manage Stock Locations",
    groups: [PermissionGroup.All, PermissionGroup.Stock, PermissionGroup.InventaryModule],
  }),
  // StockCreate : PermissionItem.create({id:71, title:"Add new Stock", groups:[PermissionGroup.All, PermissionGroup.Stock]}),
  StockUpdate: PermissionItem.create({
    id: 72,
    title: "Update Stock",
    groups: [PermissionGroup.All, PermissionGroup.Stock, PermissionGroup.InventaryModule],
  }),

  // StockRemove : PermissionItem.create({id:73, title:"Delete Stock", groups:[PermissionGroup.All, PermissionGroup.Stock]}),

  StockUpdate: PermissionItem.create({
    id: 72,
    title: "Update Stock",
    groups: [PermissionGroup.All, PermissionGroup.Stock, PermissionGroup.InventaryModule],
  }),

  ViewStockTransfer: PermissionItem.create({
    id: 237,
    title: "Access Stock Transfer",
    groups: [PermissionGroup.All, PermissionGroup.StockTransfer],
  }),

  // Channel Permissions
  ChannelView: PermissionItem.create({
    id: 80,
    title: "View Channel",
    groups: [PermissionGroup.All, PermissionGroup.Channel, PermissionGroup.AddSaleOrder, PermissionGroup.AddProduct, PermissionGroup.AddPurchaseOrder],
  }),
  // ChannelCreate : PermissionItem.create({
  //:    id=81: title="Add new Channel", groups:[PermissionGroup.All, PermissionGroup.Channel]}
  // )
  ChannelUpdate: PermissionItem.create({
    id: 82,
    title: "Update Channel",
    groups: [PermissionGroup.All, PermissionGroup.Channel, PermissionGroup.InventaryModule, PermissionGroup.ForStockUpdate],
  }),
  // ChannelRemove : PermissionItem.create({id:83: title:"Delete Channel"},
  // groups=[PermissionGroup.All, PermissionGroup.Channel])

  // Supplier Permissions
  SupplierView: PermissionItem.create({
    id: 90,
    title: "View Supplier",
    groups: [PermissionGroup.All, PermissionGroup.Supplier, PermissionGroup.InventaryModule, PermissionGroup.AddPurchaseOrder],
  }),
  // SupplierCreate : PermissionItem.create({
  //:    id=91: title="Add new Supplier", groups:[PermissionGroup.All, PermissionGroup.Supplier]}
  // )
  SupplierUpdate: PermissionItem.create({
    id: 92,
    title: "Update Supplier",
    groups: [PermissionGroup.All, PermissionGroup.Supplier, PermissionGroup.InventaryModule],
  }),
  // SupplierRemove : PermissionItem.create({
  //:    id=93: title="Delete Supplier", groups:[PermissionGroup.All, PermissionGroup.Supplier]}
  // )

  //////////////////////////////
  // Sale Module //
  //////////////////////////////

  // Customer Permissions
  CustomerView: PermissionItem.create({
    id: 100,
    title: "View Customer",
    groups: [PermissionGroup.All, PermissionGroup.Customer, PermissionGroup.SaleModule],
  }),
  // CustomerCreate : PermissionItem.create({
  //:    id=101: title="Add new Customer", groups:[PermissionGroup.All, PermissionGroup.Customer]}
  // )
  CustomerUpdate: PermissionItem.create({
    id: 102,
    title: "Update Customer",
    groups: [PermissionGroup.All, PermissionGroup.Customer, PermissionGroup.SaleModule],
  }),
  // CustomerRemove : PermissionItem.create({
  //:    id=103: title="Delete Customer", groups:[PermissionGroup.All, PermissionGroup.Customer]}
  // )
  // Balance adjustment
  CustomerBalanceAdjustment: PermissionItem.create({
    id: 194,
    title: "Balance Adjustment",
    groups: [PermissionGroup.All, PermissionGroup.BalanceAdjustment],
  }),

  // SaleOrder Permissions
  SaleOrderView: PermissionItem.create({
    id: 110,
    title: "View Sale Order",
    groups: [PermissionGroup.All, PermissionGroup.SaleOrder, PermissionGroup.SaleModule],
  }),
  // SaleOrderCreate : PermissionItem.create({
  //:    id=111: title="Add new Sale Order", groups:[PermissionGroup.All, PermissionGroup.SaleOrder]}
  // )
  SaleOrderEdit: PermissionItem.create({
    id: 112,
    title: "Edit Sale Order",
    // groups: [PermissionGroup.All, PermissionGroup.SaleOrder, PermissionGroup.SaleModule, PermissionGroup.AddSaleOrder],
    groups: [PermissionGroup.All, PermissionGroup.SaleOrder],
  }),
  SaleOrderCustomerSwitch: PermissionItem.create({
    id: 113,
    title: "Switch Sale Order Customer",
    groups: [PermissionGroup.All, PermissionGroup.SaleOrder],
  }),
  // SaleOrderRemove : PermissionItem.create({
  //:    id=113: title="Delete Sale Order", groups:[PermissionGroup.All, PermissionGroup.SaleOrder]}
  // )
  SaleOrderUpdate: PermissionItem.create({
    id: 114,
    title: "Update Sale Order",
    // groups: [PermissionGroup.All, PermissionGroup.SaleOrder, PermissionGroup.SaleModule, PermissionGroup.AddSaleOrder],
    groups: [PermissionGroup.All, PermissionGroup.SaleOrder],
  }),
  SaleOrderAssignPicker: PermissionItem.create({
    id: 115,
    title: "Assign Picker",
    groups: [PermissionGroup.All, PermissionGroup.SaleOrder],
  }),
  // Mirrors server/constants/permissions.py (ids 292-294).
  SaleOrderViewNetCostPrice: PermissionItem.create({
    id: 292,
    title: "View Net Cost Price",
    groups: [PermissionGroup.All, PermissionGroup.SaleOrder],
  }),
  SaleOrderViewMargin: PermissionItem.create({
    id: 293,
    title: "View Margin",
    groups: [PermissionGroup.All, PermissionGroup.SaleOrder],
  }),
  SaleOrderPreserveSalePrice: PermissionItem.create({
    id: 294,
    title: "Preserve Sale Prices Against Product",
    groups: [PermissionGroup.All, PermissionGroup.SaleOrder],
  }),

  // Payment Permissions
  PaymentView: PermissionItem.create({
    id: 120,
    title: "View Payment",
    groups: [PermissionGroup.All, PermissionGroup.Payment, PermissionGroup.SaleModule, PermissionGroup.AddSaleOrder],
  }),
  // PaymentCreate : PermissionItem.create({
  //:    id=121: title="Add new Payment", groups:[PermissionGroup.All, PermissionGroup.Payment]}
  // )
  PaymentUpdate: PermissionItem.create({
    id: 122,
    title: "Update Payment",
    groups: [PermissionGroup.All, PermissionGroup.Payment, PermissionGroup.SaleModule],
  }),
  // PaymentRemove : PermissionItem.create({
  //:    id=123: title="Delete Payment", groups:[PermissionGroup.All, PermissionGroup.Payment]}
  // )

  // Coupon permissions
  CouponView: PermissionItem.create({
    id: 150,
    title: "View Coupon",
    groups: [PermissionGroup.All, PermissionGroup.Coupon, PermissionGroup.SaleModule],
  }),
  // CouponCreate : PermissionItem.create({id:151, tit:e:"Add new Coupon"},
  // groups=[PermissionGroup.All, PermissionGroup.Coupon])
  CouponUpdate: PermissionItem.create({
    id: 152,
    title: "Update Coupon",
    groups: [PermissionGroup.All, PermissionGroup.Coupon, PermissionGroup.SaleModule],
  }),
  // CouponRemove : PermissionItem.create({id:153, title:"Delete Coupon", groups:[PermissionGroup.All, PermissionGroup.Coupon]}),

  ReportingView: PermissionItem.create({
    id: 130,
    title: "View Reports",
    groups: [PermissionGroup.All, PermissionGroup.Reporting, PermissionGroup.ReportModule],
  }),
  MSAReportView: PermissionItem.create({
    id: 131,
    title: "View MSA Reports",
    groups: [PermissionGroup.All, PermissionGroup.Reporting, PermissionGroup.ReportModule],
  }),
  EcomView: PermissionItem.create({
    id: 160,
    title: "Access Ecom",
    groups: [PermissionGroup.All, PermissionGroup.Ecom],
  }),
  EcomLiveChat: PermissionItem.create({
    id: 253,
    title: "Access Ecom Live Chat",
    groups: [PermissionGroup.All, PermissionGroup.Ecom],
  }),

  // user module
  UserView: PermissionItem.create({ id: 171, title: "View User", groups: [PermissionGroup.All, PermissionGroup.User] }),
  UserUpdate: PermissionItem.create({ id: 170, title: "Update User", groups: [PermissionGroup.All, PermissionGroup.User] }),

  // Konnect Permissions
  KonnectView: PermissionItem.create({
    id: 240,
    title: "View Konnect",
    groups: [PermissionGroup.All, PermissionGroup.Konnect],
  }),
  KonnectUpdate: PermissionItem.create({
    id: 241,
    title: "Update Konnect",
    groups: [PermissionGroup.All, PermissionGroup.Konnect],
  }),

  AccessDriveApp: PermissionItem.create({ id: 238, title: "Access Driver App", groups: [PermissionGroup.All, PermissionGroup.AccessDeliveryModule] }),
  VehicleView: PermissionItem.create({ id: 239, title: "View Vehicle", groups: [PermissionGroup.All, PermissionGroup.VehicleAcess] }),
  RouteView: PermissionItem.create({ id: 246, title: "View Route", groups: [PermissionGroup.All, PermissionGroup.VehicleAcess] }),
  RouteUpdate: PermissionItem.create({ id: 247, title: "Update Route", groups: [PermissionGroup.All, PermissionGroup.VehicleAcess] }),
  VehicleUpdate: PermissionItem.create({ id: 252, title: "Update Vehicle", groups: [PermissionGroup.All, PermissionGroup.VehicleAcess] }),
  VehicleDelete: PermissionItem.create({ id: 275, title: "Delete Vehicle", groups: [PermissionGroup.All, PermissionGroup.VehicleAcess] }),
  RouteDelete: PermissionItem.create({ id: 276, title: "Delete Route", groups: [PermissionGroup.All, PermissionGroup.VehicleAcess] }),
  VehicleCreate: PermissionItem.create({ id: 277, title: "Create Vehicle", groups: [PermissionGroup.All, PermissionGroup.VehicleAcess] }),
  RouteCreate: PermissionItem.create({ id: 278, title: "Create Route", groups: [PermissionGroup.All, PermissionGroup.VehicleAcess] }),

  // Accounting - Expense / Bill / Vendor
  ExpenseBillVendorView: PermissionItem.create({ id: 259, title: "View Expense/Bill/Vendor", groups: [PermissionGroup.All, PermissionGroup.ExpenseBillVendor] }),
  ExpenseBillVendorCreate: PermissionItem.create({ id: 260, title: "Create Expense/Bill/Vendor", groups: [PermissionGroup.All, PermissionGroup.ExpenseBillVendor] }),
  ExpenseBillVendorUpdate: PermissionItem.create({ id: 261, title: "Edit Expense/Bill/Vendor", groups: [PermissionGroup.All, PermissionGroup.ExpenseBillVendor] }),
  ExpenseBillVendorVoid: PermissionItem.create({ id: 262, title: "Void Expense/Bill/Vendor", groups: [PermissionGroup.All, PermissionGroup.ExpenseBillVendor] }),

  // Accounting - Chart of Accounts
  ChartOfAccountsView: PermissionItem.create({ id: 255, title: "View Chart of Accounts", groups: [PermissionGroup.All, PermissionGroup.ChartOfAccounts] }),
  ChartOfAccountsCreate: PermissionItem.create({ id: 256, title: "Create Chart of Accounts", groups: [PermissionGroup.All, PermissionGroup.ChartOfAccounts] }),
  ChartOfAccountsUpdate: PermissionItem.create({ id: 257, title: "Edit Chart of Accounts", groups: [PermissionGroup.All, PermissionGroup.ChartOfAccounts] }),
  ChartOfAccountsVoid: PermissionItem.create({ id: 258, title: "Delete Chart of Accounts", groups: [PermissionGroup.All, PermissionGroup.ChartOfAccounts] }),

  // Accounting - Manual Journal
  ManualJournalView: PermissionItem.create({ id: 248, title: "View Manual Journal", groups: [PermissionGroup.All, PermissionGroup.JournalEntry] }),
  ManualJournalCreate: PermissionItem.create({ id: 249, title: "Create Manual Journal", groups: [PermissionGroup.All, PermissionGroup.JournalEntry] }),
  ManualJournalUpdate: PermissionItem.create({ id: 250, title: "Edit Manual Journal", groups: [PermissionGroup.All, PermissionGroup.JournalEntry] }),
  ManualJournalVoid: PermissionItem.create({ id: 251, title: "Delete Manual Journal", groups: [PermissionGroup.All, PermissionGroup.JournalEntry] }),

  // Accounting - Banking
  BankingCreate: PermissionItem.create({ id: 266, title: "Banking", groups: [PermissionGroup.All, PermissionGroup.BankingGroup] }),

  // Legacy accounting permissions still returned by the permissions API.
  AccountTypesView: PermissionItem.create({ id: 180, title: "View Account Types", groups: [PermissionGroup.All] }),
  AccountTypesUpdate: PermissionItem.create({ id: 181, title: "Update Account Types", groups: [PermissionGroup.All] }),
  AccountLedgerView: PermissionItem.create({ id: 182, title: "View Account Ledger", groups: [PermissionGroup.All] }),
  AccountLedgerUpdate: PermissionItem.create({ id: 183, title: "Update Account Ledger", groups: [PermissionGroup.All] }),
  ItemView: PermissionItem.create({ id: 184, title: "View Item", groups: [PermissionGroup.All] }),
  ItemUpdate: PermissionItem.create({ id: 185, title: "Update Item", groups: [PermissionGroup.All] }),
  ItemDelete: PermissionItem.create({ id: 186, title: "Delete Item", groups: [PermissionGroup.All] }),
  BillView: PermissionItem.create({ id: 187, title: "View Bill", groups: [PermissionGroup.All] }),
  BillUpdate: PermissionItem.create({ id: 188, title: "Update Bill", groups: [PermissionGroup.All] }),
  ManufacturerView: PermissionItem.create({ id: 200, title: "View Manufacturer", groups: [PermissionGroup.All] }),
  ManufacturerUpdate: PermissionItem.create({ id: 201, title: "Update Manufacturer", groups: [PermissionGroup.All] }),
  ExpenseView: PermissionItem.create({ id: 230, title: "View Expense", groups: [PermissionGroup.All] }),
  ExpenseCreate: PermissionItem.create({ id: 231, title: "Create Expense", groups: [PermissionGroup.All] }),
  ExpenseUpdate: PermissionItem.create({ id: 232, title: "Update Expense", groups: [PermissionGroup.All] }),
  ExpenseDelete: PermissionItem.create({ id: 233, title: "Delete Expense", groups: [PermissionGroup.All] }),
  ExpensePark: PermissionItem.create({ id: 234, title: "Park Expense", groups: [PermissionGroup.All] }),
  ExpenseSubmit: PermissionItem.create({ id: 235, title: "Submit Expense", groups: [PermissionGroup.All] }),
  ExpenseVoid: PermissionItem.create({ id: 236, title: "Void Expense", groups: [PermissionGroup.All] }),
  VendorView: PermissionItem.create({ id: 263, title: "View Vendor", groups: [PermissionGroup.All] }),
  VendorCreate: PermissionItem.create({ id: 242, title: "Create Vendor", groups: [PermissionGroup.All] }),
  VendorUpdate: PermissionItem.create({ id: 243, title: "Update Vendor", groups: [PermissionGroup.All] }),
  VendorDelete: PermissionItem.create({ id: 244, title: "Delete Vendor", groups: [PermissionGroup.All] }),

  // Accounting - Department
  AccountingDepartmentView: PermissionItem.create({ id: 267, title: "View Departments", groups: [PermissionGroup.All, PermissionGroup.DepartmentGroup] }),
  AccountingDepartmentCreate: PermissionItem.create({ id: 268, title: "Create Departments", groups: [PermissionGroup.All, PermissionGroup.DepartmentGroup] }),
  AccountingDepartmentUpdate: PermissionItem.create({ id: 269, title: "Edit Departments", groups: [PermissionGroup.All, PermissionGroup.DepartmentGroup] }),
  AccountingDepartmentVoid: PermissionItem.create({ id: 270, title: "Delete Departments", groups: [PermissionGroup.All, PermissionGroup.DepartmentGroup] }),

  // Accounting - period lock ("close the books through a date")
  AccountingPeriodLockManage: PermissionItem.create({ id: 272, title: "Manage Accounting Period Lock", groups: [PermissionGroup.All, PermissionGroup.ChartOfAccounts] }),
  POSClockInOutView: PermissionItem.create({ id: 273, title: "POS Clock in/out Report", groups: [PermissionGroup.All, PermissionGroup.Reporting] }),
  GeneratePasswordPin: PermissionItem.create({ id: 274, title: "Generate Password & PIN", groups: [PermissionGroup.All, PermissionGroup.User] }),
  // Spiff Permissions
  SpiffView: PermissionItem.create({
    id: 280,
    title: "View Spiff",
    groups: [PermissionGroup.All, PermissionGroup.Spiff],
  }),
  SpiffUpdate: PermissionItem.create({
    id: 281,
    title: "Update Spiff",
    groups: [PermissionGroup.All, PermissionGroup.Spiff],
  }),
  KaiAccess: PermissionItem.create({
    id: 282,
    title: "Access KAI Assistant",
    groups: [PermissionGroup.All, PermissionGroup.Kai],
  }),
};

export const DELIVERY_PERMISSION_ROWS = [
  {
    label: "Vehicle",
    view: Permission.VehicleView,
    create: Permission.VehicleCreate,
    update: Permission.VehicleUpdate,
    voidPerm: Permission.VehicleDelete,
  },
  {
    label: "Route",
    view: Permission.RouteView,
    create: Permission.RouteCreate,
    update: Permission.RouteUpdate,
    voidPerm: Permission.RouteDelete,
  },
  {
    label: "Access Driver App",
    create: Permission.AccessDriveApp,
  },
];

export const DELIVERY_PERMISSION_IDS = DELIVERY_PERMISSION_ROWS.flatMap(({ view, create, update, voidPerm }) => [view, create, update, voidPerm])
  .filter(Boolean)
  .map(({ id }) => id);

export const ACCOUNTING_BANKING_DEPENDENT_PERMISSIONS = [
  Permission.ChartOfAccountsView,
  Permission.ChartOfAccountsCreate,
  Permission.ChartOfAccountsUpdate,
  Permission.ChartOfAccountsVoid,
  Permission.ExpenseBillVendorView,
  Permission.ExpenseBillVendorCreate,
  Permission.ExpenseBillVendorUpdate,
  Permission.ExpenseBillVendorVoid,
  Permission.ManualJournalView,
  Permission.ManualJournalCreate,
  Permission.ManualJournalUpdate,
  Permission.ManualJournalVoid,
];

export const ACCOUNTING_PERMISSION_IDS = [
  Permission.AccountTypesView.id,
  Permission.AccountTypesUpdate.id,
  Permission.AccountLedgerView.id,
  Permission.AccountLedgerUpdate.id,
  Permission.ItemView.id,
  Permission.ItemUpdate.id,
  Permission.ItemDelete.id,
  Permission.BillView.id,
  Permission.BillUpdate.id,
  Permission.CustomerBalanceAdjustment.id,
  Permission.ManufacturerView.id,
  Permission.ManufacturerUpdate.id,
  Permission.ExpenseView.id,
  Permission.ExpenseCreate.id,
  Permission.ExpenseUpdate.id,
  Permission.ExpenseDelete.id,
  Permission.ExpensePark.id,
  Permission.ExpenseSubmit.id,
  Permission.ExpenseVoid.id,
  Permission.VendorView.id,
  Permission.VendorCreate.id,
  Permission.VendorUpdate.id,
  Permission.VendorDelete.id,
  Permission.ChartOfAccountsView.id,
  Permission.ChartOfAccountsCreate.id,
  Permission.ChartOfAccountsUpdate.id,
  Permission.ChartOfAccountsVoid.id,
  Permission.ExpenseBillVendorView.id,
  Permission.ExpenseBillVendorCreate.id,
  Permission.ExpenseBillVendorUpdate.id,
  Permission.ExpenseBillVendorVoid.id,
  Permission.ManualJournalView.id,
  Permission.ManualJournalCreate.id,
  Permission.ManualJournalUpdate.id,
  Permission.ManualJournalVoid.id,
  Permission.BankingCreate.id,
  Permission.AccountingDepartmentView.id,
  Permission.AccountingDepartmentCreate.id,
  Permission.AccountingDepartmentUpdate.id,
  Permission.AccountingDepartmentVoid.id,
];

const ACCOUNTING_PERMISSION_TITLES = new Set([
  Permission.AccountTypesView.title,
  Permission.AccountTypesUpdate.title,
  Permission.AccountLedgerView.title,
  Permission.AccountLedgerUpdate.title,
  Permission.ItemView.title,
  Permission.ItemUpdate.title,
  Permission.ItemDelete.title,
  Permission.BillView.title,
  Permission.BillUpdate.title,
  Permission.CustomerBalanceAdjustment.title,
  Permission.ManufacturerView.title,
  Permission.ManufacturerUpdate.title,
  Permission.ExpenseView.title,
  Permission.ExpenseCreate.title,
  Permission.ExpenseUpdate.title,
  Permission.ExpenseDelete.title,
  Permission.ExpensePark.title,
  Permission.ExpenseSubmit.title,
  Permission.ExpenseVoid.title,
  Permission.VendorView.title,
  Permission.VendorCreate.title,
  Permission.VendorUpdate.title,
  Permission.VendorDelete.title,
  Permission.ChartOfAccountsView.title,
  Permission.ChartOfAccountsCreate.title,
  Permission.ChartOfAccountsUpdate.title,
  Permission.ChartOfAccountsVoid.title,
  "Void Chart of Accounts",
  Permission.ExpenseBillVendorView.title,
  Permission.ExpenseBillVendorCreate.title,
  Permission.ExpenseBillVendorUpdate.title,
  Permission.ExpenseBillVendorVoid.title,
  "View Expense / Bill / Vendor",
  "Create Expense / Bill / Vendor",
  "Edit Expense / Bill / Vendor",
  "Void Expense / Bill / Vendor",
  Permission.ManualJournalView.title,
  Permission.ManualJournalCreate.title,
  Permission.ManualJournalUpdate.title,
  Permission.ManualJournalVoid.title,
  "View Journal Entry",
  "Create Journal Entry",
  "Update Journal Entry",
  "Void Journal Entry",
  Permission.BankingCreate.title,
  "Create Banking",
  Permission.AccountingDepartmentView.title,
  Permission.AccountingDepartmentCreate.title,
  Permission.AccountingDepartmentUpdate.title,
  Permission.AccountingDepartmentVoid.title,
]);

export const isAccountingPermission = (permission) => {
  const permissionId = permission?.id ?? permission;
  const permissionTitle = permission?.title;

  if (permissionTitle) {
    return ACCOUNTING_PERMISSION_TITLES.has(permissionTitle);
  }

  return ACCOUNTING_PERMISSION_IDS.includes(permissionId);
};

export const ACCOUNTING_PERMISSION_DEPENDENCIES = {
  [Permission.ExpenseBillVendorView.id]: [Permission.ChartOfAccountsView],
  [Permission.ManualJournalView.id]: [Permission.ChartOfAccountsView],
  [Permission.BankingCreate.id]: ACCOUNTING_BANKING_DEPENDENT_PERMISSIONS,
};

export const expandPermissionsWithDependencies = (permissions = [], availablePermissions = []) => {
  const availablePermissionsById = new Map(
    [...Object.values(Permission), ...(availablePermissions || [])]
      .filter((permission) => permission && typeof permission === "object" && permission.id)
      .map((permission) => [permission.id, permission])
  );
  const expandedPermissionsById = new Map();

  const addPermission = (permission) => {
    const permissionId = permission?.id ?? permission;

    if (!permissionId || expandedPermissionsById.has(permissionId)) {
      return;
    }

    expandedPermissionsById.set(permissionId, availablePermissionsById.get(permissionId) || permission);
    (ACCOUNTING_PERMISSION_DEPENDENCIES[permissionId] || []).forEach(addPermission);
  };

  (permissions || []).forEach(addPermission);

  return Array.from(expandedPermissionsById.values());
};

export const hasAnyModulePermissions = (moduleName = []) => {
  const admin = getCurrentAdmin();
  const adminPermissionIds = expandPermissionsWithDependencies(admin?.permissions || []).map((permission) => permission?.id ?? permission);
  for (const permission of moduleName) {
    if (!!adminPermissionIds.includes(permission.id)) {
      return [true, permission];
    }
  }
  return false;
};
export const getCurrentAdmin = () => {
  const defaultAdmin = { permissions: [] };

  try {
    if (!Object.keys(JSON.parse(JSON.parse(localStorage.getItem("persist:demo1-auth"))?.admin || {}))?.length) {
      localStorage.setItem("persist:demo1-auth", null);
      window.location = "/auth/logout";
    }
    return JSON.parse(JSON.parse(localStorage.getItem("persist:demo1-auth"))?.admin) || defaultAdmin;
  } catch (error) {
    localStorage.setItem("persist:demo1-auth", null);
    window.location = "/auth/logout";
    return defaultAdmin;
  }
};

export const hasPermissionsV2 = (requiredPermissions) => {
  const admin = getCurrentAdmin();
  const missingPerms = [];
  const adminPermissionIds = expandPermissionsWithDependencies(admin?.permissions || []).map((permission) => permission?.id ?? permission);
  if (admin.master_admin) {
    return true;
  }
  // console.log("permissions", missingPerms, admin?.permissions, requiredPermissions);
  for (const permission of requiredPermissions) {
    if (!adminPermissionIds.includes(permission.id)) {
      missingPerms.push(permission);
    }
  }

  if (missingPerms.length) {
    return false;
  }
  return true;
};

export const hasPermissions = (requiredPermissions) => {
  try {
    const admin = getCurrentAdmin();
    const missingPerms = [];
    const adminPermissionIds = expandPermissionsWithDependencies(admin?.permissions || []).map((permission) => permission?.id ?? permission);
    if (admin.master_admin) {
      return [true];
    }
    if (!requiredPermissions) {
      return [false];
    }
    for (const permission of requiredPermissions) {
      if (!adminPermissionIds.includes(permission.id)) {
        missingPerms.push(permission);
      }
    }
    if (missingPerms.length) {
      return [false, missingPerms];
    }
    return [true];
  } catch (err) {
    console.error(err);
    return [false];
  }
};

export const hasRestrictivePermission = (permission) => {
  const admin = getCurrentAdmin();
  return !!admin?.permissions?.includes(permission.id);
};
export const isSuperuser = () => {
  const admin = getCurrentAdmin();
  return admin.master_admin;
};
export const validatePermission = (requiredPermissions) => {
  const [success, permission] = hasPermissions(requiredPermissions);
  if (!success) {
    // show error notification
    return false;
  }
  return true;
};

// @requiredPermissions({id: 1}, {id: 2})
// function test(){
// console.log('changing route')
// }
// console.log("test1", PermissionGroup.SaleModule.permissions());
// console.log("test2", PermissionGroup.Attribute.permissions());
